import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies';
import { JwtHelper } from 'angular2-jwt';

@Injectable()
export class JwtService {

  constructor() { }

  /**
   * access_token 존재 여부 확인(cookie)
   */
  checkCookie() {

      return Cookie.check('access_token');
  }

  /**
   * access_token 존재 여부 확인 (session storage)
   */
  checkAccessToken() {
      const token = sessionStorage.getItem('access_token');

      if (token == null || token.length < 1) {
        return false;
      } else {
        return true;
      }
  }

  /**
   * username 가져오기 (cookie)
   */
  getUserName() {

    const jwtHelper: JwtHelper = new JwtHelper();
    const token = Cookie.get('access_token');
    return jwtHelper.decodeToken(token).user_name;
  }


  /**
   * username 가져오기 (session storage)
   */
  getUserNameFromSession() {
    const jwtHelper: JwtHelper = new JwtHelper();
    const token = sessionStorage.getItem('access_token');
    return jwtHelper.decodeToken(token).user_name;
  }

  /**
   * name 가져오기 (session storage)
   */
  getNameFromSession() {
    const jwtHelper: JwtHelper = new JwtHelper();
    const token = sessionStorage.getItem('access_token');
    return jwtHelper.decodeToken(token).name;
  }

  /**
   * profileUrl 가져오기 (session storage)
   */
  getProfileUrlFromSession() {
    const jwtHelper: JwtHelper = new JwtHelper();
    const token = sessionStorage.getItem('access_token');
    return jwtHelper.decodeToken(token).profile_url;
  }


  /**
   * userId 가져오기 (session storage)
   */
  getUserIdFromSession() {
    const jwtHelper: JwtHelper = new JwtHelper();
    const token = sessionStorage.getItem('access_token');
    return jwtHelper.decodeToken(token).id;
  }

  /**
  * 헤더 설정 ( cookie )
  */
  getHeaders() {
    const headers = new Headers({'authorization' : 'bearer ' + Cookie.get('access_token')});
    return headers;
  }

  /**
  * 헤더 설정 ( session storage )
  */
  getHeadersFromSession() {
    const headers = new Headers({'authorization' : 'bearer ' + sessionStorage.getItem('access_token')});
    return headers;
  }

  /**
   * 토큰 만료 체크
   */
  checkTokenExpiration() {
    const jwtHelper: JwtHelper = new JwtHelper();
    const token = sessionStorage.getItem('access_token');

    return jwtHelper.isTokenExpired(token);
  }

  /**
   * 토큰 갱신 요청
   */
  refreshToken() {

  }


}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/d90c5bcf/0/gaia/gaia-ui-angular/src/app/jwt/jwt.service.ts